import React, { useEffect } from 'react';
import { initProfileButtons } from '../../utils/userUtil';

function CardButtons({
  userInfoObject,
  isFeed,
  isUserProfile,
  showBtn,
  setShowBtn,
  sayHiBtn,
  pendingBtn,
  followingBtn,
  followBtn,
  confirmTextBtn,
  addFriendBtn,
}) {
  const {
    isAuthorMentor,
    isFollowed,
    isFriend,
    isRequestReceived,
    isRequestSent,
  } = userInfoObject;

  function renderProfileButtons() {
    if (isAuthorMentor === true) {
      if (isFollowed) {
        setShowBtn({ ...initProfileButtons, following: true });
      } else {
        setShowBtn({ ...initProfileButtons, follow: true });
      }
    } else {
      if (isRequestReceived === true) {
        setShowBtn({ ...initProfileButtons, confirm: true });
      } else {
        if (isUserProfile) {
          if (
            (isRequestSent && isFollowed) ||
            (isRequestSent && !isFollowed && !isFriend)
          ) {
            setShowBtn({ ...initProfileButtons, pending: true });
          } else if (
            (isFriend && !isRequestSent) ||
            (isRequestSent && !isFriend)
          ) {
            setShowBtn({ ...initProfileButtons, following: true });
          } else {
            setShowBtn({ ...initProfileButtons, addFriend: true });
          }
        } else {
          // This UI is for follow or following or champion list page.
          if (isRequestSent && isFollowed) {
            setShowBtn({ ...initProfileButtons, pending: true });
          } else if (isFriend) {
            setShowBtn({ ...initProfileButtons, sayHi: true });
          } else if (isRequestSent && !isFriend && isFollowed) {
            setShowBtn({ ...initProfileButtons, following: true });
          } else if (isRequestSent) {
            setShowBtn({ ...initProfileButtons, pending: true });
          } else {
            setShowBtn({ ...initProfileButtons, addFriend: true });
          }
        }
      }
    }
  }

  function renderFeedButtons() {
    if (isAuthorMentor) {
      if (isFollowed) {
        setShowBtn({ ...initProfileButtons, following: true });
      } else {
        setShowBtn({ ...initProfileButtons, follow: true });
      }
    } else {
      if (!isFriend && !isRequestReceived) {
        setShowBtn({ ...initProfileButtons, addFriend: true });
      }
    }
  }
  useEffect(() => {
    isFeed ? renderFeedButtons() : renderProfileButtons();
    //eslint-disable-next-line
  }, []);
  const { addFriend, pending, follow, following, confirm, sayHi } = showBtn;
  return (
    <React.Fragment>
      {follow
        ? followBtn()
        : following
        ? followingBtn()
        : pending
        ? pendingBtn()
        : confirm
        ? confirmTextBtn()
        : sayHi
        ? sayHiBtn()
        : addFriend
        ? addFriendBtn()
        : ''}
    </React.Fragment>
  );
}

export default CardButtons;
